import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import StudentWeeklyReport from 'Components/Student/Reports/Weekly/StudentWeeklyReport';
import { StaffPanel } from 'Components/StaffPanel';

const NotFound: React.FC = () => {
  return (
    <div className='alert alert-danger'>
      <h1 className='alert-heading'>Not Found</h1>
      <p>No file was found at the location specified.</p>
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <Switch>
        <Route exact path='/student' component={StaffPanel} />
        <Route
          path='/student/:studentId/weekly/:week?'
          component={StudentWeeklyReport}
        />
        <Route component={NotFound} />
      </Switch>
    </Router>
  );
};

export default App;
